export const clientPhotosConstants = {
    LOAD_REQUEST: 'CLIENT_PHOTOS_LOAD_REQUEST',
    LOAD_SUCCESS: 'CLIENT_PHOTOS_LOAD_SUCCESS',
    LOAD_FAILURE: 'CLIENT_PHOTOS_LOAD_FAILURE',

    UPLOAD_OPTIMISTIC: 'CLIENT_PHOTOS_UPLOAD_OPTIMISTIC',
    UPLOAD_SUCCESS: 'CLIENT_PHOTOS_UPLOAD_SUCCESS',
    UPLOAD_FAILURE: 'CLIENT_PHOTOS_UPLOAD_FAILURE',

    PATCH_OPTIMISTIC: 'CLIENT_PHOTOS_PATCH_OPTIMISTIC',
    PATCH_SUCCESS: 'CLIENT_PHOTOS_PATCH_SUCCESS',
    PATCH_FAILURE: 'CLIENT_PHOTOS_PATCH_FAILURE',

    DELETE_OPTIMISTIC: 'CLIENT_PHOTOS_DELETE_OPTIMISTIC',
    DELETE_COMMIT: 'CLIENT_PHOTOS_DELETE_COMMIT',
    DELETE_UNDO: 'CLIENT_PHOTOS_DELETE_UNDO',
    DELETE_FAILURE: 'CLIENT_PHOTOS_DELETE_FAILURE',

    SHARE_CONSENT_OPTIMISTIC: 'CLIENT_PHOTOS_SHARE_CONSENT_OPTIMISTIC',
    SHARE_CONSENT_SUCCESS: 'CLIENT_PHOTOS_SHARE_CONSENT_SUCCESS',
    SHARE_CONSENT_FAILURE: 'CLIENT_PHOTOS_SHARE_CONSENT_FAILURE',

    CONSENT_SET: 'CLIENT_PHOTOS_CONSENT_SET',
    CONSENT_REVOKE: 'CLIENT_PHOTOS_CONSENT_REVOKE',

    SALON_TAGS_LOAD_SUCCESS: 'CLIENT_PHOTOS_SALON_TAGS_LOAD_SUCCESS',
    CONTEXT_TAGS_LOAD_SUCCESS: 'CLIENT_PHOTOS_CONTEXT_TAGS_LOAD_SUCCESS',
};

// Fixed quick-pick suggestions with reserved colour coding. Any other
// tag (custom, freeform) renders with the neutral "custom" style.
export const PHOTO_TAG_SUGGESTIONS = ['before', 'after', 'reference', 'progress'];
export const FIXED_TAG_SET = new Set(PHOTO_TAG_SUGGESTIONS);
